const VISIT_FREQUENCY = [
    { value: 0, text: 'Weekly' },
    { value: 1, text: 'Monthly' },
    { value: 2, text: 'Yearly' }
];

type VISIT_FREQUENCY = typeof VISIT_FREQUENCY;

export default VISIT_FREQUENCY;